import { Box, Typography } from "@material-ui/core";
import { FC } from "react";

const CenteredMessage: FC<CenteredMessageProps> = ({ message, height = "100%" }) => {
  return (
    <Box data-testid="centered-message-box" display="flex" alignItems="center" justifyContent="center" height={height}>
      <Typography data-testid="centered-message-typography" color="textSecondary">
        {message}
      </Typography>
    </Box>
  );
};

interface CenteredMessageProps {
  message: string;
  height?: string;
}

export default CenteredMessage;
